import { useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import NewCompanyDocument from 'modules/documents/components/NewCompanyDocument'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { isCompanyPublicSpace } from 'modules/documents/lib/Documents'

const NewCompanyDocumentPage = () => {
  const { navigation } = useNavigation()
  const { folder, space, initialFolder } = useOutletContext<{
    folder: Folder
    space: string
    initialFolder: Folder
  }>()

  let backRoute = ''
  if (isCompanyPublicSpace(space)) {
    if (folder && folder.id) {
      backRoute = navigation.files.companyFiles.folderId.fullPath({ folderId: folder.id })
    } else {
      backRoute = navigation.files.companyFiles.list.fullPath()
    }
  } else {
    if (folder && folder.id) {
      backRoute = navigation.files.managementDocuments.folderId.fullPath({ folderId: folder.id })
    } else {
      backRoute = navigation.files.managementDocuments.list.fullPath()
    }
  }

  return <NewCompanyDocument folder={initialFolder || folder} backRoute={backRoute} space={space} />
}

export default NewCompanyDocumentPage
